var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("教育经历\n        "), _c('el-button', {
    staticClass: "pull-right f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return [_c('education', {
      key: item.id || item._index,
      ref: 'education' + index,
      refInFor: true,
      attrs: {
        "init": item
      },
      on: {
        "remove": _vm.removeItem
      }
    })]
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1626af2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/educationModule.vue
// module id = null
// module chunks = 